module.exports = __webpack_public_path__ + "ipetbooking-landing/img/home_data.d78e440a.png";